module.exports = __webpack_public_path__ + "img/cri.e7680ebe.svg";